
export class SocialMedia{
    static LINKED_IN = 'https://www.linkedin.com/in/abhishek~kumar/';
    static STACK_OVERFLOW = 'https://stackoverflow.com/users/10015930/abhishek-kumar';
    static GITHUB = 'https://github.com/aabbhishek';
    static MAIL_TO = 'mailto:kumarabhishek.kumar97@gmail.com?subject=Connecting to Abhishek&body=Hi Abhishek,';
}